export enum HorizontalAlignEnum {
    CENTER = 'center',
    LEFT = 'left',
    RIGHT = 'right',
}
